import { render, staticRenderFns } from "./psuBmForm.vue?vue&type=template&id=07f4f588&scoped=true"
import script from "./psuBmForm.vue?vue&type=script&lang=js"
export * from "./psuBmForm.vue?vue&type=script&lang=js"
import style0 from "./psuBmForm.vue?vue&type=style&index=0&id=07f4f588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f4f588",
  null
  
)

export default component.exports